import { Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/styles';

export const styles = (theme: Theme): StyleRules => ({
  root: {
    width: '30px',
    height: '30px',
    // border: `1px solid ${theme.palette.grey[50]}`,
    // display: 'none',
    cursor: 'pointer',
    marginLeft: '10px',
    textAlign: 'center',
    [theme.breakpoints.up('xs')]: {
      width: '28px',
      height: '28px',
      display: 'block',
    },
    [theme.breakpoints.up('sm')]: {
      width: '28px',
      height: '28px',
      display: 'block',
    },
    [theme.breakpoints.up('md')]: {
      width: '28px',
      height: '28px',
      display: 'block',
    },
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  userIcon: {
    width: '28px',
    height: '28px',
    margin: 'auto',
  },
  paper: {
    width: '100%',
    top:'80px',
    backgroundColor:"transparent",
    height:'auto'
  },
  drawerBody: {
    padding: '0',
    width: '100%',
    borderBottom: '2px solid var(--333333, #333)',
    background: 'var(--Linear, linear-gradient(90deg, #EDEDFE 0%, #D8E6FC 50.74%, #DDF0F0 100%))',
    '& a:hover': {
      color: 'blue',
    },
  },
  drawerContent: {
    padding: '0 20px',
  },
  link: {
    color: '#000000',
    fontWeight: 600,
    fontSize: '28px',
    borderBottom: '1.4px solid rgba(255, 255, 255, 0.2)',
    borderRadius: 0,
    padding: 0,
    marginTop: '15px',
    lineHeight:'80px',
    height:'80px',
    '& span': {
      justifyContent: 'center',
    },
  },
  linkWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  activeLink: {
    color: 'blue',
  },
  socialBox:{
    height:'80px',
    lineHeight:'80px',
    borderTop:'1px solid #333',
    marginTop:"40px",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg':{
      margin:'0 15px'
    }
  }
});
